import React, { Component } from "react";
import { Field } from "redux-form";
import 'react-widgets/dist/css/react-widgets.css';
import DropdownList from 'react-widgets/lib/DropdownList'

const divStyle = {
    backgroundColor: '#fff'
};


const renderDropdownList = ({ input, data, valueField, textField }) =>
    <DropdownList {...input}
        data={data}
        valueField={valueField}
        textField={textField}
        onChange={input.onChange} />



const propertyType = [{ ptype: 'Single Family         ', value: '1' },
{ ptype: 'Condominium           ', value: '1' },
{ ptype: 'Multi-Family 2-4 units', value: '1' },
{ ptype: 'Manufactured          ', value: '1' },
{ ptype: 'Commercial            ', value: '1' },
    { ptype: 'Select                ', value: '1' }];

const occupancyType = [
{ptype: 'Vacant', value : '1' },
{ ptype: 'Tenant', value : '1' },
{ ptype: 'Second Home', value : '1' },
{ ptype: 'New Construction', value : '1' },
{ ptype: 'Owner', value : '1' },
{ ptype: 'Select', value : '1' }];

const intendedUseType = [
    { ptype: 'Refinance				 ', value: '1' },
    { ptype: 'Purchase		', value: '1' },
    { ptype: 'Ascertain Market Value	', value: '1' },
    { ptype: 'Servicing	', value: '1' },
    { ptype: 'Other	', value: '1' },
    { ptype: 'Select', value: '1' }
];

const valueType = [
    { ptype: 'As Is', value: '1' },
    { ptype: 'As Is and As Repaired', value: '1' },
    { ptype: 'Subject To', value: '1' },
    { ptype: 'Retrospective', value: '1' },
    { ptype: 'Other(please specify in additional instructions)', value: '1' }

]

class Title extends Component {
    render() {
        return (
            <div className="form-row col-12">
                <div className="col-4" style={divStyle}>
                    <div>
                        <div className="form-group"><label>Intended Use</label>
                            <Field name="IntendedUse" component={renderDropdownList} data={intendedUseType}  valueField="value" textField="ptype" />
                        </div>
                    </div>
                </div>
                <div className="col-4">
                    <div></div>
                    <div>
                        <div className="form-group"><label>Property Type</label>
                            
                                <Field
                                    name="PropertyType"
                                    component={renderDropdownList}
                                    data={propertyType}
                                    valueField="value"
                                    textField="ptype" />

                        </div>
                    </div>
                </div>



                <div className="col-4" style={divStyle}>
                        <div className="form-group"><label>Occupancy</label>

                            <Field
                                name="OccupancyType"
                                component={renderDropdownList}
                                data={occupancyType}
                                valueField="value"
                                textField="ptype" />
                        </div>
                </div>
                <div className="col-4" style={divStyle}>
                        <div className="form-group"><label>Value Type</label>

                            <Field
                                name="ValueType"
                                component={renderDropdownList}
                                data={valueType}
                                valueField="value"
                                textField="ptype" />
                        </div>

                </div>
            </div>
        );
    };
};
export default Title;